import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Route, Switch, Redirect, useHistory, useRouteMatch } from 'react-router';
import { useConnector, useUser } from '../../../contexts';
import { StyledText } from '../../../components/StyledText';
import ConnectorGuide from '../../../components/PublishingGuide/ConnectorGuide';
import ConnectorActivityConsole from './ConnectorActivityConsole';

const mixpanelToken: string = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN!;
mixpanel.init(mixpanelToken, { debug: true });

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingTop: '40px'
  }
}));

const ConnectorHome = () => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const classes = useStyles();
  const { profile, fetchProfile, shouldShowIncompleteProfileGuide } = useConnector();
  const { userInfo } = useUser();

  const handleOpenProfile = async () => {
    history.push(`/connector/${profile.id}`);
  };

  useEffect(() => {
    if (userInfo && userInfo.profileId && profile.id !== userInfo.profileId) {
      fetchProfile(userInfo.profileId);
    }
    // fetch profile never changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, userInfo]);

  return (
    <div className={classes.root}>
      {shouldShowIncompleteProfileGuide
        && (
        <ConnectorGuide
          profile={profile}
          handleClick={handleOpenProfile}
        />
        )}
      <ConnectorActivityConsole />
    </div>
  );
};

export default ConnectorHome;
